import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';

interface NoPad {
  noPad?: 'bottom' | 'top' | 'both';
}
interface IPageSection {
  recessed?: boolean;
  noBorder?: boolean;
  bleed: { left: number; right: number };
}

export const PageSectionWrapper = styled.div<IPageSection>`
  position: relative;
  padding: 0 ${layout.measurements.spacing050};

  ${({ recessed, theme }) =>
    recessed &&
    css`
      background-color: ${theme.bg.quaternary};
    `};

  &,
  :before,
  :after {
    ${p =>
      !p.noBorder &&
      !p.recessed &&
      css`
        border-bottom: 1px solid ${p.theme.lines.primary};
      `};
  }

  ${p => css`
    ${media.largeUp`
      :before {
        position: absolute;
        left: ${p.bleed.left ? `${p.bleed.left}px` : '-50vw'};
        right: ${p.bleed.right ? `${p.bleed.right}px` : '-50vw'};
        z-index: -1;
        content: '';
        height: 100%;

        ${
          !p.noBorder &&
          !p.recessed &&
          css`
            border-bottom: 1px solid ${p.theme.lines.primary};
          `
        };

        ${
          p.recessed &&
          css`
            background-color: ${p.theme.bg.quaternary};
          `
        };
      }
    `}
  `}
`;

export const PageSectionContent = styled.section<NoPad>`
  ${p => {
    if (p.noPad === 'bottom') {
      return css`
        padding-top: ${layout.measurements.spacing200};
        padding-bottom: 0;
        ${media.mediumUp`
            padding-top: ${layout.measurements.spacing400};
        `};
      `;
    }
    if (p.noPad === 'top') {
      return css`
        padding-bottom: ${layout.measurements.spacing200};
        padding-top: 0;
        ${media.mediumUp`
          padding-bottom: ${layout.measurements.spacing400};
        `};
      `;
    }
    if (p.noPad === 'both') {
      return css`
        padding: 0;
      `;
    }

    return css`
      padding: ${layout.measurements.spacing200} 0;
      ${media.mediumUp`
        padding: ${layout.measurements.spacing400} 0;
      `};
    `;
  }};

  :empty {
    display: none;
  }
`;
